import { ReactElement } from 'react'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

import Meta from '@/components/base/Meta'
import Builder from '@/components/layout/Builder'
import Layout from '@/components/layout/Layout'
import HeroHome from '@/components/sections/HeroHome'
import usePagePrecache from '@/hooks/usePagePrecache'
import { isTouch } from '@/utils/device'
import { mapPageStaticProps } from '@/utils/pageData'
import { getPromiseFromFetch } from '@/utils/request'

import { WPPageData } from '@/types'

export default function Home(
  pageData: InferGetStaticPropsType<typeof getStaticProps>
) {
  usePagePrecache(true, [
    isTouch ? pageData.acf.video.mobile.url : pageData.acf.video.desktop.url
  ])
  return (
    <>
      <HeroHome
        poster={pageData.acf.poster}
        video={pageData.acf.video}
        title={pageData.acf.title}
      />
      <div data-builder className="relative z-10">
        <Builder pageData={pageData} />
      </div>
    </>
  )
}

Home.getLayout = function getLayout(page: ReactElement, props: WPPageData) {
  return (
    <Layout pageData={props}>
      <Meta pageData={props} />
      {page}
    </Layout>
  )
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  if (locale === 'default') return { notFound: true }

  const { data: pageData } = await getPromiseFromFetch<WPPageData>({
    method: 'get',
    url: `/${locale}`
  })

  if (!pageData) return { notFound: true }

  return {
    props: {
      ...(await mapPageStaticProps(pageData))
    }
  }
}
